<script setup>
import { onMounted } from "vue";
import { Tab } from "bootstrap";
import { storeToRefs } from "pinia";
import Multiselect from "vue-multiselect";
const { state, stateCotizacion, tablaTIR, clientes } = storeToRefs(
  useCotizacionEstandarStore()
);
import LoadingSpinner from "@/components/LoadingComponent";
import { useCotizacionEstandarStore } from "@/store/cotizaciones/estandar/";
import useCotizacionEstandarDatosStore from "@/store/cotizaciones/estandar/datos";
import { useCotizacionEstandar } from "@/composables/useCotizacionEstandar";
import CotizacionEstandarCalculos from "@/components/cotizacion/estandar/calculos/";
const { getTablaTIR, arrendamientosTipo } = useCotizacionEstandar();

getTablaTIR();

const {
  calculaComision,
  calculaEnganche,
  calculaIva,
  calculaIvaRenta,
  calculaMontoFinanciar,
  calculaReferencia,
  calculaRelacionRentaEquipo,
  calculaRentaEnDeposito,
  calculaRentaMensual,
  calculaSubtotal,
  calculaTotalPagoInicial,
  calculaTotalRenta,
  calculaValorResidualCalculo,
  obtenerDatoPorCodigo,
  obtenerDatoPorCodigoPlazo,
  obtenerDatoPorPlazo,
} = useCotizacionEstandarDatosStore();

const {
  anticipoNormal,
  montoFinanciar,
  montoFinanciarIVA,
  precioFinal,
  rangoOperacionLabel,
  tdcEurosVentanilla,
  tdcInformativo,
  tdcUSD,
  tdcUSDvsEUR,
} = storeToRefs(useCotizacionEstandarDatosStore());

onMounted(() => {
  const firstTabEl = document.querySelector("#pills-home-tab");
  if (firstTabEl) {
    const firstTab = new Tab(firstTabEl);
    firstTab.show();
  }
});
</script>

<template>
  <LoadingSpinner v-if="tablaTIR.length === 0 && clientes.length === 0" />
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body row">
            <div class="col-md-12">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link active"
                    id="datos-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#datos"
                    type="button"
                    role="tab"
                    aria-controls="datos"
                    aria-selected="true"
                  >
                    Datos
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    id="calculos-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#calculos"
                    type="button"
                    role="tab"
                    aria-controls="calculos"
                    aria-selected="false"
                  >
                    Cálculos
                  </button>
                </li>
              </ul>

              <div class="tab-content">
                <div
                  class="tab-pane active"
                  id="datos"
                  role="tabpanel"
                  aria-labelledby="datos-tab"
                >
                  <div class="row">
                    <div class="col-md-2">
                      <div class="form-group">
                        <label for="cliente">Cliente</label>
                        <multiselect
                          v-model="state.cliente_id"
                          :options="clientes"
                          :value="[clientes]"
                          :searchable="true"
                          label="label"
                          track-by="id"
                          required
                          placeholder="Seleccione"
                          :object="true"
                          :disabled="consultandoInfo"
                        ></multiselect>
                      </div>
                      <div class="form-group">
                        <label for="descripcion">Descripción</label>
                        <input class="form-control" id="descripcion" />
                      </div>
                      <div class="form-group">
                        <label for="cliente">Tipo de equipo</label>
                        <select
                          class="form-control"
                          id="cliente"
                          v-model="state.arrendamiento"
                        >
                          <option :value="undefined">Seleccione</option>
                          <option
                            :value="nombre"
                            v-for="{ nombre } in arrendamientosTipo"
                            :key="nombre"
                          >
                            {{ nombre }}
                          </option>
                          <option value="credito">Credito simple</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label for="cliente">Tipo financiamiento</label>
                        <select
                          class="form-control"
                          id="cliente"
                          v-model="state.tipoArrendamiento"
                        >
                          <option value="puro">Arrendamiento puro</option>
                          <option value="financiero">
                            Arrendamiento Financiero
                          </option>
                          <option value="credito">Credito simple</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label for="valor">Valor equipo</label>
                        <input
                          class="form-control"
                          id="valor"
                          v-model="state.valorEquipo"
                        />
                      </div>
                      <div class="form-group">
                        <label for="moneda_equipo">Moneda equipo</label>
                        <select
                          class="form-control"
                          id="moneda_equipo"
                          v-model="state.monedaEquipo"
                        >
                          <option value="MXN">MXN</option>
                          <option value="USD">USD</option>
                          <option value="EUR">EUR</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label for="moneda_operación">Moneda operación</label>
                        <select
                          class="form-control"
                          id="moneda_operación"
                          v-model="state.monedaOperacion"
                        >
                          <option value="MXN">MXN</option>
                          <option value="USD">USD</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>Seguro</label>
                        <input
                          type="tel"
                          class="form-control"
                          v-model.number="stateCotizacion.seguro"
                          autocomplete="off"
                        />
                      </div>
                      <div class="form-group">
                        <label>Gastos Legales</label>
                        <input
                          type="tel"
                          class="form-control"
                          v-model.number="stateCotizacion.gastosLegales"
                          autocomplete="off"
                        />
                      </div>
                      <div class="form-group">
                        <label>Gastos Importación</label>
                        <input
                          type="tel"
                          class="form-control"
                          v-model.number="stateCotizacion.gastosImportacion"
                          autocomplete="off"
                        />
                      </div>
                      <div class="form-group">
                        <label>Fecha cierre</label>
                        <input
                          type="date"
                          class="form-control"
                          v-model="state.fechaCierre"
                        />
                      </div>
                      <div class="form-group">
                        <label for="moneda_operación"
                          >Fecha primer vencimiento</label
                        >
                        <input
                          type="date"
                          class="form-control"
                          v-model="state.fechaPrimerVencimiento"
                        />
                      </div>
                      <div class="form-group">
                        <label for="moneda_operación">Descripción</label>
                        <textarea
                          autocomplete="off"
                          class="form-control"
                          v-model="state.descripcion"
                          rows="4"
                        />
                      </div>
                    </div>
                    <div class="col-md-10 px-4">
                      <section>
                        <div class="table-responsive">
                          <table
                            class="table table-sm table-striped table-bordered table-hover text-xs"
                          >
                            <tbody>
                              <tr>
                                <th>TdcInformativo</th>
                                <td>
                                  {{ tdcInformativo }}
                                </td>
                              </tr>
                              <tr>
                                <th>TdC USD DOF + 6%</th>
                                <td>
                                  {{ tdcUSD }}
                                </td>
                              </tr>
                              <tr>
                                <th>TdC EURO vs USD</th>
                                <td>
                                  {{ tdcUSDvsEUR }}
                                </td>
                              </tr>
                              <tr>
                                <th>TdC EUROS Ventanilla + 4%</th>
                                <td>
                                  {{ tdcEurosVentanilla }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  Precio final en {{ state.monedaOperacion }}
                                </th>
                                <td>
                                  {{ precioFinal }}
                                </td>
                              </tr>
                              <tr>
                                <th>Anticipo normal</th>
                                <td>{{ anticipoNormal }}%</td>
                              </tr>
                              <tr>
                                <th>
                                  Monto a financiar en
                                  {{ state.monedaOperacion }} sin IVA
                                </th>
                                <td>
                                  {{ montoFinanciar }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  Monto a financiar en
                                  {{ state.monedaOperacion }} con IVA
                                </th>
                                <td>
                                  {{ montoFinanciarIVA }}
                                </td>
                              </tr>
                              <tr>
                                <th>Rango de operación</th>
                                <td>
                                  {{ rangoOperacionLabel }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <h5>{{ obtenerDatoPorCodigo }}</h5>
                        <div class="d-flex align-items-center gap-2">
                          <span class="text-sm fw-bold">Plazo</span>
                          <select
                            class="form-control-sm w-10"
                            v-model.number="stateCotizacion.plazo"
                          >
                            <option value="12">12</option>
                            <option value="24">24</option>
                            <option value="36">36</option>
                            <option value="48">48</option>
                            <option value="60">60</option>
                          </select>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                          <span class="text-sm fw-bold">Tipo cotización</span>
                          <select
                            class="form-control-sm w-20"
                            v-model="stateCotizacion.tipo"
                          >
                            <option value="Normal">Normal</option>
                          </select>
                        </div>
                        <table
                          class="table table-bordered text-center table-striped table-sm"
                          style="font-size: 12px"
                        >
                          <thead>
                            <tr class="bg-light fw-bold">
                              <th></th>
                              <th></th>
                              <th>12</th>
                              <th>24</th>
                              <th>36</th>
                              <th>48</th>
                              <th>60</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="bg-light">Subsidio Vendor</td>
                              <td>No aplica</td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.subsidioVendor_12"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.subsidioVendor_24"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.subsidioVendor_36"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.subsidioVendor_48"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.subsidioVendor_60"
                                />
                                %
                              </td>
                            </tr>
                            <tr>
                              <td class="bg-light">Anticipo Capital</td>
                              <td>{{ calculaReferencia("anticipo") }}%</td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.anticipoCapital_12"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.anticipoCapital_24"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.anticipoCapital_36"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.anticipoCapital_48"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.anticipoCapital_60"
                                />
                                %
                              </td>
                            </tr>
                            <tr>
                              <td class="bg-light">Tasa</td>
                              <td>{{ calculaReferencia("tasa") }}%</td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.tasa_12"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.tasa_24"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.tasa_36"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.tasa_48"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.tasa_60"
                                />
                                %
                              </td>
                            </tr>
                            <tr>
                              <td class="bg-light">Comisión</td>
                              <td>{{ calculaReferencia("comision") }}%</td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.comisionPorc_12"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.comisionPorc_24"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.comisionPorc_36"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.comisionPorc_48"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.comisionPorc_60"
                                />
                                %
                              </td>
                            </tr>
                            <tr>
                              <td class="bg-light">Última renta</td>
                              <td>
                                {{ calculaReferencia("ultima_renta", false) }}
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.ultimaRenta_12"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.ultimaRenta_24"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.ultimaRenta_36"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.ultimaRenta_48"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.ultimaRenta_60"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td class="bg-light">Residual cálculo</td>
                              <td>
                                {{ calculaReferencia("residual_calculo") }}%
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="
                                    stateCotizacion.residualCalculoPorc_12
                                  "
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="
                                    stateCotizacion.residualCalculoPorc_24
                                  "
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="
                                    stateCotizacion.residualCalculoPorc_36
                                  "
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="
                                    stateCotizacion.residualCalculoPorc_48
                                  "
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="
                                    stateCotizacion.residualCalculoPorc_60
                                  "
                                />
                                %
                              </td>
                            </tr>
                            <tr>
                              <td class="bg-light">Buy Out</td>
                              <td>{{ calculaReferencia("buy_out") }}%</td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.buyOut_12"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.buyOut_24"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.buyOut_36"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.buyOut_48"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.buyOut_60"
                                />
                                %
                              </td>
                            </tr>
                            <tr>
                              <td class="bg-light">Residual cliente</td>
                              <td>
                                {{ calculaReferencia("residual_cliente") }}%
                              </td>
                              <td>
                                {{
                                  stateCotizacion.residualCalculoPorc_12 +
                                  stateCotizacion.buyOut_12
                                }}
                                %
                              </td>
                              <td>
                                {{
                                  stateCotizacion.residualCalculoPorc_24 +
                                  stateCotizacion.buyOut_24
                                }}
                                %
                              </td>
                              <td>
                                {{
                                  stateCotizacion.residualCalculoPorc_36 +
                                  stateCotizacion.buyOut_36
                                }}
                                %
                              </td>
                              <td>
                                {{
                                  stateCotizacion.residualCalculoPorc_48 +
                                  stateCotizacion.buyOut_48
                                }}
                                %
                              </td>
                              <td>
                                {{
                                  stateCotizacion.residualCalculoPorc_60 +
                                  stateCotizacion.buyOut_60
                                }}
                                %
                              </td>
                            </tr>
                            <tr>
                              <td class="bg-light">OC o VF cálculo</td>
                              <td>{{ calculaReferencia("opcion_compra") }}%</td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.opCalculo_12"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.opCalculo_24"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.opCalculo_36"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.opCalculo_48"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.opCalculo_60"
                                />
                                %
                              </td>
                            </tr>
                            <tr>
                              <td class="bg-light">OC o VF cliente</td>
                              <td>
                                {{ calculaReferencia("opcion_compra_oculta") }}%
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.ocCliente_12"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.ocCliente_24"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.ocCliente_36"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.ocCliente_48"
                                />
                                %
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.ocCliente_60"
                                />
                                %
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr class="bg-secondary text-white">
                              <td>TIR objetivo</td>
                              <td>{{ calculaReferencia("tir_objetivo") }}%</td>
                              <td>
                                {{ obtenerDatoPorPlazo(12, "tir_objetivo") }}
                                %
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(24, "tir_objetivo") }}
                                %
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(36, "tir_objetivo") }}
                                %
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(48, "tir_objetivo") }}
                                %
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(60, "tir_objetivo") }}
                                %
                              </td>
                            </tr>
                            <tr class="bg-secondary text-white">
                              <td>TIR Ejercicio</td>
                              <td>21.75%</td>
                              <td>9%</td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                          </tfoot>
                        </table>
                      </section>
                      <section class="mt-5 table-responsive">
                        <table
                          class="table table-bordered text-center table-striped table-sm"
                          style="font-size: 12px"
                        >
                          <thead>
                            <tr>
                              <th>Plazo</th>
                              <th>12</th>
                              <th>24</th>
                              <th>36</th>
                              <th>48</th>
                              <th>60</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Cotizar</td>
                              <td class="bg-success text-white">Sí</td>
                              <td class="bg-success text-white">Sí</td>
                              <td class="bg-success text-white">Sí</td>
                              <td class="bg-success text-white">Sí</td>
                              <td class="bg-danger text-white">No</td>
                            </tr>
                            <tr>
                              <td>Etiqueta</td>
                              <td>{{ obtenerDatoPorCodigoPlazo(12) }}</td>
                              <td>{{ obtenerDatoPorCodigoPlazo(24) }}</td>
                              <td>{{ obtenerDatoPorCodigoPlazo(36) }}</td>
                              <td>{{ obtenerDatoPorCodigoPlazo(48) }}</td>
                              <td>{{ obtenerDatoPorCodigoPlazo(60) }}</td>
                            </tr>
                            <tr>
                              <td>Enganche</td>
                              <td>{{ obtenerDatoPorPlazo(12, "anticipo") }}</td>
                              <td>
                                {{ obtenerDatoPorPlazo(24, "anticipo") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(36, "anticipo") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(48, "anticipo") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(60, "anticipo") }}%
                              </td>
                            </tr>
                            <tr>
                              <td>Tasa de interés</td>
                              <td>{{ obtenerDatoPorPlazo(12, "tasa") }}%</td>
                              <td>{{ obtenerDatoPorPlazo(24, "tasa") }}%</td>
                              <td>{{ obtenerDatoPorPlazo(36, "tasa") }}%</td>
                              <td>{{ obtenerDatoPorPlazo(48, "tasa") }}%</td>
                              <td>{{ obtenerDatoPorPlazo(60, "tasa") }}%</td>
                            </tr>
                            <tr>
                              <td>Comisión de apertura</td>
                              <td>
                                {{ obtenerDatoPorPlazo(12, "comision") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(24, "comision") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(36, "comision") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(48, "comision") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(60, "comision") }}%
                              </td>
                            </tr>
                            <tr>
                              <td>Renta en depósito</td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.numRentaDeposito_12"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.numRentaDeposito_24"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.numRentaDeposito_36"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.numRentaDeposito_48"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="text-center w-20 flex-none"
                                  v-model="stateCotizacion.numRentaDeposito_60"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>Residual cálculo</td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(12, "residual_calculo")
                                }}%
                              </td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(24, "residual_calculo")
                                }}%
                              </td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(36, "residual_calculo")
                                }}%
                              </td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(48, "residual_calculo")
                                }}%
                              </td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(60, "residual_calculo")
                                }}%
                              </td>
                            </tr>
                            <tr>
                              <td>Buy Out AP</td>
                              <td>{{ obtenerDatoPorPlazo(12, "buy_out") }}%</td>
                              <td>{{ obtenerDatoPorPlazo(24, "buy_out") }}%</td>
                              <td>{{ obtenerDatoPorPlazo(36, "buy_out") }}%</td>
                              <td>{{ obtenerDatoPorPlazo(48, "buy_out") }}%</td>
                              <td>{{ obtenerDatoPorPlazo(60, "buy_out") }}%</td>
                            </tr>
                            <tr>
                              <td>Residual cliente</td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(12, "residual_cliente")
                                }}%
                              </td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(24, "residual_cliente")
                                }}%
                              </td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(36, "residual_cliente")
                                }}%
                              </td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(48, "residual_cliente")
                                }}%
                              </td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(60, "residual_cliente")
                                }}%
                              </td>
                            </tr>
                            <tr>
                              <td>Opción de Compra Cálculo</td>
                              <td>
                                {{ obtenerDatoPorPlazo(12, "opcion_compra") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(24, "opcion_compra") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(36, "opcion_compra") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(48, "opcion_compra") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(60, "opcion_compra") }}%
                              </td>
                            </tr>
                            <tr>
                              <td>Buy Out AF o CS</td>
                              <td>
                                {{ obtenerDatoPorPlazo(12, "buy_out_oculto") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(24, "buy_out_oculto") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(36, "buy_out_oculto") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(48, "buy_out_oculto") }}%
                              </td>
                              <td>
                                {{ obtenerDatoPorPlazo(60, "buy_out_oculto") }}%
                              </td>
                            </tr>
                            <tr>
                              <td>Opción de Compra Cliente</td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(
                                    12,
                                    "opcion_compra_oculta"
                                  )
                                }}%
                              </td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(
                                    24,
                                    "opcion_compra_oculta"
                                  )
                                }}%
                              </td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(
                                    36,
                                    "opcion_compra_oculta"
                                  )
                                }}%
                              </td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(
                                    48,
                                    "opcion_compra_oculta"
                                  )
                                }}%
                              </td>
                              <td>
                                {{
                                  obtenerDatoPorPlazo(
                                    60,
                                    "opcion_compra_oculta"
                                  )
                                }}%
                              </td>
                            </tr>
                            <tr>
                              <td class="pt-4 border-top bt-dark">Enganche</td>
                              <td class="pt-4 border-top bt-dark">
                                {{ calculaEnganche(12) }}
                              </td>
                              <td class="pt-4 border-top bt-dark">
                                {{ calculaEnganche(24) }}
                              </td>
                              <td class="pt-4 border-top bt-dark">
                                {{ calculaEnganche(36) }}
                              </td>
                              <td class="pt-4 border-top bt-dark">
                                {{ calculaEnganche(48) }}
                              </td>
                              <td class="pt-4 border-top bt-dark">
                                {{ calculaEnganche(60) }}
                              </td>
                            </tr>
                            <tr>
                              <td>Monto a financiar</td>
                              <td>{{ calculaMontoFinanciar(12) }}</td>
                              <td>{{ calculaMontoFinanciar(24) }}</td>
                              <td>{{ calculaMontoFinanciar(36) }}</td>
                              <td>{{ calculaMontoFinanciar(48) }}</td>
                              <td>{{ calculaMontoFinanciar(60) }}</td>
                            </tr>
                            <tr>
                              <td>Valor residual cálculo</td>
                              <td>{{ calculaValorResidualCalculo(12) }}</td>
                              <td>{{ calculaValorResidualCalculo(24) }}</td>
                              <td>{{ calculaValorResidualCalculo(36) }}</td>
                              <td>{{ calculaValorResidualCalculo(48) }}</td>
                              <td>{{ calculaValorResidualCalculo(60) }}</td>
                            </tr>
                            <tr>
                              <td>Renta Mensual</td>
                              <td>{{ calculaRentaMensual(12) }}</td>
                              <td>{{ calculaRentaMensual(24) }}</td>
                              <td>{{ calculaRentaMensual(36) }}</td>
                              <td>{{ calculaRentaMensual(48) }}</td>
                              <td>{{ calculaRentaMensual(60) }}</td>
                            </tr>
                            <tr>
                              <td>Relación Renta/Equipo</td>
                              <td>{{ calculaRelacionRentaEquipo(12) }}</td>
                              <td>{{ calculaRelacionRentaEquipo(24) }}</td>
                              <td>{{ calculaRelacionRentaEquipo(36) }}</td>
                              <td>{{ calculaRelacionRentaEquipo(48) }}</td>
                              <td>{{ calculaRelacionRentaEquipo(60) }}</td>
                            </tr>
                            <tr>
                              <td class="border-top bt-dark pt-4">Enganche</td>
                              <td class="border-top bt-dark pt-4">
                                {{ stateCotizacion.enganche_12 }}
                              </td>
                              <td class="border-top bt-dark pt-4">
                                {{ stateCotizacion.enganche_24 }}
                              </td>
                              <td class="border-top bt-dark pt-4">
                                {{ stateCotizacion.enganche_36 }}
                              </td>
                              <td class="border-top bt-dark pt-4">
                                {{ stateCotizacion.enganche_48 }}
                              </td>
                              <td class="border-top bt-dark pt-4">
                                {{ stateCotizacion.enganche_60 }}
                              </td>
                            </tr>
                            <tr>
                              <td>Comisión</td>
                              <td>{{ calculaComision(12) }}</td>
                              <td>{{ calculaComision(24) }}</td>
                              <td>{{ calculaComision(36) }}</td>
                              <td>{{ calculaComision(48) }}</td>
                              <td>{{ calculaComision(60) }}</td>
                            </tr>
                            <tr>
                              <td>Subtotal</td>
                              <td>{{ calculaSubtotal(12) }}</td>
                              <td>{{ calculaSubtotal(24) }}</td>
                              <td>{{ calculaSubtotal(36) }}</td>
                              <td>{{ calculaSubtotal(48) }}</td>
                              <td>{{ calculaSubtotal(60) }}</td>
                            </tr>
                            <tr>
                              <td>Iva</td>
                              <td>{{ calculaIva(12) }}</td>
                              <td>{{ calculaIva(24) }}</td>
                              <td>{{ calculaIva(36) }}</td>
                              <td>{{ calculaIva(48) }}</td>
                              <td>{{ calculaIva(60) }}</td>
                            </tr>
                            <tr>
                              <td>Renta en Deposito</td>
                              <td>{{ calculaRentaEnDeposito(12) }}</td>
                              <td>{{ calculaRentaEnDeposito(24) }}</td>
                              <td>{{ calculaRentaEnDeposito(36) }}</td>
                              <td>{{ calculaRentaEnDeposito(48) }}</td>
                              <td>{{ calculaRentaEnDeposito(60) }}</td>
                            </tr>
                            <tr>
                              <td>Total Pago Inicial</td>
                              <td>{{ calculaTotalPagoInicial(12) }}</td>
                              <td>{{ calculaTotalPagoInicial(24) }}</td>
                              <td>{{ calculaTotalPagoInicial(36) }}</td>
                              <td>{{ calculaTotalPagoInicial(48) }}</td>
                              <td>{{ calculaTotalPagoInicial(60) }}</td>
                            </tr>
                            <tr>
                              <td class="border-top bt-dark pt-4">
                                Valor de la renta
                              </td>
                              <td class="border-top bt-dark pt-4">
                                {{ stateCotizacion.rentaMensual_12 }}
                              </td>
                              <td class="border-top bt-dark pt-4">
                                {{ stateCotizacion.rentaMensual_24 }}
                              </td>
                              <td class="border-top bt-dark pt-4">
                                {{ stateCotizacion.rentaMensual_36 }}
                              </td>
                              <td class="border-top bt-dark pt-4">
                                {{ stateCotizacion.rentaMensual_48 }}
                              </td>
                              <td class="border-top bt-dark pt-4">
                                {{ stateCotizacion.rentaMensual_60 }}
                              </td>
                            </tr>
                            <tr>
                              <td>IVA Renta</td>
                              <td>{{ calculaIvaRenta(12) }}</td>
                              <td>{{ calculaIvaRenta(24) }}</td>
                              <td>{{ calculaIvaRenta(36) }}</td>
                              <td>{{ calculaIvaRenta(48) }}</td>
                              <td>{{ calculaIvaRenta(60) }}</td>
                            </tr>
                            <tr>
                              <td>Total Renta (con IVA)</td>
                              <td>{{ calculaTotalRenta(12) }}</td>
                              <td>{{ calculaTotalRenta(24) }}</td>
                              <td>{{ calculaTotalRenta(36) }}</td>
                              <td>{{ calculaTotalRenta(48) }}</td>
                              <td>{{ calculaTotalRenta(60) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </section>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane"
                  id="calculos"
                  role="tabpanel"
                  aria-labelledby="calculos-tab"
                >
                  <CotizacionEstandarCalculos />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.bt-dark {
  border-top: 1px #444444 solid !important;
}

/* input {
  border: none;
  background: transparent !important;
} */
.form-control {
  flex: 0 0 auto !important;
}
</style>
